import { useToast } from "@qubit/autoparts";

import { useAppSelector } from "~/app/store";
import { extractReceipientId } from "~/lib/helpers";
import { useUserSubscription } from "~/lib/signalr";
import { selectAuth0UserId } from "~/redux/selectors/authSelectors";

import { selectUsersFulfillmentCenter } from "~/redux/selectors/storeSelectors";
import { SendMessageDto } from "~/types/api";

export const useUserMessages = () => {
  const currentUserId = useAppSelector(selectAuth0UserId);
  const currentRecipientId = extractReceipientId(currentUserId);
  const { warningToast } = useToast();

  const usersFulfillmentCenter = useAppSelector(selectUsersFulfillmentCenter);

  const userSubscription = (event: SendMessageDto) => {
    if (
      usersFulfillmentCenter?.fulfillmentCenterId !==
        event.fulfillmentCenterId ||
      event.userId !== currentRecipientId
    )
      return;

    warningToast(event.message);
  };

  useUserSubscription(userSubscription);
};
